import { z } from 'zod';

export const PublicUserSchema = z.object({
   id: z.string(),
   image: z.string().nullable().optional(),
   username: z.string().optional().nullable(),
   publicKey: z.string().nullable().optional(),
   fullname: z.string().nullable().optional(),
});

export const UserSchema = z.object({
   id: z.string().optional(),
   publicKey: z.string().nullable().optional(),
   image: z.string().nullable().optional(),
   username: z
      .string()

      .optional()
      .nullable(),
   fullname: z.string().nullable().optional(),
   phrase: z.string().nullable().optional(),
   telegram: z.string().nullable().optional(),
   twitter: z.string().nullable().optional(),
   email: z.string().nullable().optional(),
   createdAt: z.string().nullable().optional(),
   address: z.string().nullable().optional(),
   city: z.string().nullable().optional(),
   state: z.string().nullable().optional(),
   zip: z.string().nullable().optional(),
   country: z.string().nullable().optional(),
   phone: z.string().nullable().optional(),
   hasPassword: z.boolean().nullable().optional(),
   referralCode: z.string().nullable().optional(),
   referredBy: PublicUserSchema.nullable(),
});

export const UserPutSchema = z.object({
   username: z
      .string()
      .min(3, { message: 'Username must be at least 3 characters long' })
      .max(20, { message: 'Username must be at most 20 characters long' })
      .optional()
      .nullable(),
   phrase: z.string().nullable().optional(),
   // isVisible: z.boolean(),
   fullname: z.string().nullable().optional(),
   address: z.string().nullable().optional(),
   city: z.string().nullable().optional(),
   state: z.string().nullable().optional(),
   zip: z.string().nullable().optional(),
   country: z.string().nullable().optional(),
   phone: z.string().nullable().optional(),
});

export const UserBalanceSchema = z.object({
   points: z.number().min(0),
   tickets: z.number().min(0),
   balls: z.number().min(0),
});
